@if (hasLink) { @if (isExternalLink) {
<a
  [ngClass]="linkClasses"
  [href]="disabled ? null : link"
  [target]="target"
  [attr.rel]="target === '_blank' ? 'noopener noreferrer' : null"
  [attr.aria-disabled]="disabled"
  (click)="onClick($event)">
  <ng-container *ngTemplateOutlet="linkContent"></ng-container>
</a>
} @else {
<a [ngClass]="linkClasses" [routerLink]="disabled ? null : link" [state]="state" [target]="target" [attr.aria-disabled]="disabled" (click)="onClick($event)">
  <ng-container *ngTemplateOutlet="linkContent"></ng-container>
</a>
} } @else {
<a [ngClass]="linkClasses" [attr.aria-disabled]="disabled" (click)="onClick($event)">
  <ng-container *ngTemplateOutlet="linkContent"></ng-container>
</a>
}

<ng-template #linkContent>
  @if (isSizeProvided) {
  <sg-text class="sg-link__text" [variant]="textVariant">{{ text }}</sg-text>
  } @else {
  <span class="sg-link__text">{{ text }}</span>
  } @if (showIcon) {
  <mat-icon class="sg-link__icon">{{ icon }}</mat-icon>
  }
</ng-template>
